import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { QrScanNodeView } from '../views/QrScanNode';
import { OFFLINE_MODE } from '@/config/offline';

export const qrScanDefinition: NodeDefinition<'qrScan'> = {
  label: 'QR Scan',
  showInPalette: true,
  paletteColor: 'bg-cyan-100 border-cyan-500 text-cyan-700',
  miniMapColor: '#06b6d4',
  defaultData: { label: 'QR Scan' },
  view: QrScanNodeView,
  run: async (_node, ctx, log) => {
    if (!ctx.qrScanner) {
      log('[QR Scan] エラー: QR読み取りが利用できません');
      return;
    }

    const result = await ctx.qrScanner.scan();
    switch (result.status) {
      case 'success':
        ctx.lastValue = result.value;
        log(`[QR Scan] "${result.value}" を読み取りました`);
        return;
      case 'cancelled':
        log('[QR Scan] キャンセルしました');
        return;
      case 'timeout':
        log('[QR Scan] タイムアウトしました');
        return;
      case 'error':
        log(`[QR Scan] エラー: ${result.message}`);
        return;
    }
  },
  help: {
    title: [t('QR Scan（'), r('読', 'よ'), t('み'), r('取', 'と'), t('り）')],
    description: OFFLINE_MODE ? [
      t('ロボットのカメラで QR コードを読み取り、書かれている内容を「ことば」にします。'),
      t('オフラインでは Say Text に直接つなげません（事前作成した10個の文章のみ話せます）。Keyword Switch で分けて Text Edit の文章を話してください。'),
    ] : [
      t('カメラで QR コードを'),
      r('読', 'よ'),
      t('み'),
      r('取', 'と'),
      t('って、'),
      r('書', 'か'),
      t('かれている'),
      r('内容', 'ないよう'),
      t('を「ことば」にします。'),
      r('読', 'よ'),
      t('み'),
      r('取', 'と'),
      t('った「ことば」は、つぎのカードに'),
      r('渡', 'わた'),
      t('されます。'),
    ],
  },
};
